















































import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { BatchDto } from '@/Application/Batch'
import DeclarationsForm from '@/UI/AuctionB/Declarations/DeclarationsForm.vue'
import DeclarationsBatchDetail from '@/UI/AuctionB/Declarations/DeclarationsBatchDetail.vue'
import DeclarationsLoteRisco from '@/UI/AuctionB/Declarations/DeclarationsLoteRisco.vue'
import DeclarationsLoteResultas from '@/UI/AuctionB/Declarations/DeclarationsLoteResultas.vue'
import CurrentBatchDisplay from '@/UI/AuctionB/Declarations/CurrentBatchDisplay.vue'
import { Bid } from '@/Infrastructure/Store/AuctionB/Bid'
import { Offer } from '@/Infrastructure/Store/AuctionB/Offer'

const auctionStore = namespace('auction')
const auctionStoreB = namespace('auctionb')
const procedureStore = namespace('procedure')

@Component({
  components: {
    DeclarationsForm,
    DeclarationsLoteRisco,
    DeclarationsLoteResultas,
    DeclarationsBatchDetail,
    CurrentBatchDisplay
  }
})

export default class DeclarationsLayout extends Vue {
  currentBatchIndex = 0

  @auctionStore.Getter
  public procedureData!: string[]

  @procedureStore.Getter
  public resultasBatches!: BatchDto[]

  @procedureStore.Getter
  public riscoBatches!: BatchDto[]

  @procedureStore.Getter
  public currentProcedureType!: string

  @auctionStoreB.Getter
  public offers!: Offer[]

  @auctionStoreB.Action
  public upsertOffer!: (payload: Offer) => void

  get totalBatches (): number {
    return this.selectedBatches.length
  }

  get currentOffer (): Offer {
    const currentOffer = this.offers.find(current => current.batchId === this.currentBatch.batchId)
    if (currentOffer === undefined) {
      return {
        batchId: this.currentBatch.batchId,
        global: { textBid: '', numberBid: '' }
      }
    }
    return currentOffer
  }

  get selectedBatches (): BatchDto[] {
    const allBatches = [
      ...this.riscoBatches,
      ...this.resultasBatches
    ]
    const selectedBatches = allBatches.filter(current => {
      return this.procedureData.indexOf(current.batchId) !== -1
    })
    return selectedBatches
  }

  get currentBatch (): BatchDto {
    return this.selectedBatches[this.currentBatchIndex]
  }

  public getNextBatch (): void {
    if (this.currentBatchIndex < this.totalBatches - 1) {
      this.currentBatchIndex++
    }
  }

  public getPreviousBatch (): void {
    if (this.currentBatchIndex > 0) {
      this.currentBatchIndex--
    }
  }

  public mounted (): void {
    this.$emit('declarations-updated', {
      batches: this.selectedBatches,
      offers: this.offers
    })
  }

  public onResultasOfferUpdated ($event: Offer): void {
    this.upsertOffer($event)
    this.$emit('declarations-updated', {
      batches: this.selectedBatches,
      offers: this.offers
    })
  }

  public onRiscoOfferUpdated ($event: Bid): void {
    const offer: Offer = {
      batchId: this.currentBatch.batchId,
      global: $event
    }
    this.upsertOffer(offer)
    this.$emit('declarations-updated', {
      batches: this.selectedBatches,
      offers: this.offers
    })
  }
}
